import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.View`
  padding: 0 24px;
`;

export const Form = styled.View`
  margin-top: ${RFValue(4)}px;
`;

export const InputGroup = styled.View`
  margin-bottom: ${RFValue(12)}px;
`;

export const InputGrid = styled.View`
  flex-direction: row;
  gap: ${RFValue(12)}px;
  justify-content: space-between;
  align-items: center;
`;

export const Footer = styled.View`
  padding: ${RFValue(12)}px 24px ${RFValue(16)}px;
`;
